<template>
	<div @click.prevent="onActionClick" class="take-action-button flex-centerize">
		{{ title }}
		<SIcon class="ml-1" name="take-action-chevrons" />
	</div>
</template>

<script>
export default {
	name: 'ActionButton',
	props: {
		title: { type: String, default: '' },
	},
	methods: {
		onActionClick() {
			this.$emit('action-button-click');
		},
	},
};
</script>

<style scoped lang="scss">
.take-action-button {
	cursor: pointer;
	font-size: 12px;
	color: #5856f9;
	&:hover {
		text-decoration: underline;
	}
}
</style>
